export default (state, action) => {
  const newState = {...state};
  const {key, removeValue} = action.payload;

  // get existing query param values for the key, as an array
  let values = state[key] || [];
  if (!Array.isArray(values)) {
    values = [values];
  }

  // remove the target value from the array
  const newValues = values.filter((value) => value !== removeValue);

  // remove the old state for the key
  delete newState[key];

  // set the new state for the key, if existent
  if (newValues.length) {
    newState[key] = newValues;
  }

  return newState;
};
